'use strict';

var config = $('.js_bambuser-otoconfig').data('config');

var orgId = config.orgId;
var smartVariantOverride = config.smartVariantOverride;
var triggers = config.triggers;

const storeApi = {};
var basketProductLineItems = {};
window.localStorage.setItem('basketProductLineItems', JSON.stringify({}));

storeApi.getProduct = (productIdentifier, bambuserId) => {
    var dataProduct = config.urls.productData;
    var productId = productIdentifier ? productIdentifier.split('/').pop().split('-').pop().split('.')[0] : '';
    dataProduct = dataProduct + '?sku=' + productId;
    if (bambuserId) {
        dataProduct = dataProduct + '&id=' + bambuserId;
    }
    $.ajax({
        url: dataProduct,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            var bambuserProduct = data.product;
            return Promise.resolve(bambuserProduct);
        },
        error: function (err) {
            console.log('error', err);
            return Promise.resolve({});
        }
    });
};

//======================================== Bambuser onReady Handler ==============================================
window.onBambuserOneToOneReady = function(BambuserOneToOneEmbed) {
    // This method will be invoked when embed.js has loaded and Bambuser
    // One-to-One API is available.
    // Creating an instance directly will allow to detect connect links 
    // that will automatically open the Live Meeting overlay on page load.
    let oneToOneEmbed = new BambuserOneToOneEmbed({
        orgId: orgId, // REPLACE THIS WITH YOUR OWN ORG ID
        //  queue: 'QUEUE_ID_HERE', //if not specified, default queue configured from the dashboard will get applied

        // ACTIVATE OVERLAY WIDGET
        // The Overlay Widget (OLW) is an easy way to guide more visitors into the Call Widget.
        // By appearing automatically after configurable amount of seconds it guides visitors towards sales help at the right time.
        smartVariantOverride: smartVariantOverride, // Other options are 'Video', 'Avatar' and 'Side dock'

        // trigger 'smart' :activate the overlay widget
        // trigger 'connect-link' : activate the connect link - Unrelated to OLW, yet mandatory
        triggers: triggers,

        popupTimeoutSeconds: '2', // after how many seconds OLW appears on the first time page load (default = 60)

        // PROVIDE CUSTOMER DATA
        // Below information will be presented to the Agent during a call
        // You can either provide Build-in properties or custom properties
        // A full list of build in properties can be found on 
        // https://bambuser.com/docs/one-to-one/present-customer-data-to-agent/
        data: {
            firstName: '',
            lastName: '',
            email: ''
        },

        // Bambuser follow  ISO 639-1 Code + "-" + ISO 3166-2 as standard locale format.
        // The value should be of type string
        locale: config.locale, // Call Widget language translation for the end user (default='en-US')
        allowFirstPartyCookies: true, // Configures if embed script is allowed to write first party cookies for tracking purposes (default=true)
        enableScanning: false, // Agent app will scan for barcodes and QR codes when adding product through scanning (default=false)
        enableCartQuantitySum: true,
        merchantBaseUrl: config.urls.home
    });

    oneToOneEmbed.areQueuesOpen().then((response) => {
        // Disable a button if the queue is closed
        if (response.isOpen === false) {
            if ($('.isBrandPage').length) {
                $("#makeup-video-call .btn-shade-finder").attr('disabled', true);
            }
        } else {
            if ($('.isBrandPage').length) {
                $("#makeup-video-call .start-one-to-one").attr('disabled', false);
            }
        }
    });

    // Connect CTA button to open Bambuser One-to-One overlay.
    let button = $('.start-one-to-one');

    button.on('click' , function() {
        oneToOneEmbed.show();
        if ($('.isBrandPage').length) {
            var oneToOneHash = $(this).parents('#makeup-video-call').attr('id');
            window.location.hash = oneToOneHash;
        }
        if ($(this).hasClass('closed')) {
            window.location = config.urls.brand;
        }
    });

    // The Call Widget triggeres 'provide-product-data' event when:
    // 1. When an Agent enters a product identifier in the Agent Tool UI
    // 2. When an Agent clicks on the "Recent Product" in the Agent Tool UI
    // 3. When an Agent clicks on the "Related Product" in the Agent Tool UI
    oneToOneEmbed.on('provide-product-data', (event) => {
        event.products.forEach(({ref, type, id: bambuserId}) => {
            // Mandatory to handle at least URL and SKU
            // Use the references provided above to fetch your product object
            // Provide product data to the widget using the methods below.

            // type: "url" | "product-reference" | "scanned-code"
            let sku;
            if (type === 'url') {
                var productId = ref && ref.split('/').pop() && ref.split('/').pop().split('-').length > 0 && ref.split('/').pop().split('-').pop().split('.').length > 0 ? ref.split('/').pop().split('-').pop().split('.')[0] : '';
                if (!productId) {
                    return Promise.resolve({});
                }
                sku = productId;
            } else if (type === 'product-reference') {
                sku = ref;
            }

            var dataProduct = config.urls.productData;
            dataProduct = dataProduct + '?sku=' + sku;
            if (bambuserId) {
                dataProduct = dataProduct + '&id=' + bambuserId;
            }

            $.ajax({
                url: dataProduct,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    var yourProduct = data.product;
                    // Product mapping
                    oneToOneEmbed.updateProduct(bambuserId, (productFactory) => {
                        if (yourProduct.options) {
                            return (
                                productFactory
                                    .currency(config.currency)
                                    .locale(config.locale)
                                    .product((detailFactory) =>
                                        detailFactory
                                            .name(yourProduct.title)
                                            .sku(yourProduct.productId)
                                            .description(yourProduct.description)
                                            .url(window.location.origin + yourProduct.slug)
                                            .attributes((attribute) => {
                                                return yourProduct.options.map((attr) =>
                                                    attribute(attr.optionId)
                                                        .name(attr.name)
                                                        .options((option) =>
                                                            attr.values.map((optionName) =>
                                                                option(optionName)
                                                                    .name(optionName)
                                                            )
                                                        )
                                                );
                                            }).variations((variationFactory) =>
                                                yourProduct.variants.map((variation) =>
                                                    variationFactory()
                                                        .name(variation.title)
                                                        .url(window.location.origin + variation.slug)
                                                        .subtitle(yourProduct.brand)
                                                        .sku(variation.variationId)
                                                        .inStock(variation.available)
                                                        .imageUrls(variation.images)
                                                        .price((priceFactory) =>
                                                            priceFactory
                                                                .original(variation.original_price)
                                                                .current(variation.price)
                                                        )
                                                        .attributes((attribute) =>
                                                            yourProduct.options.map((attr) =>
                                                                attribute(
                                                                    attr.optionId,
                                                                    variation['option' + attr.optionId]
                                                                )
                                                            )
                                                        )
                                                )
                                            )
                                    )
                            );
                        } else {
                            return (
                                productFactory
                                    .currency(config.currency)
                                    .locale(config.locale)
                                    .product((detailFactory) =>
                                        detailFactory
                                            .name(yourProduct.title)
                                            .sku(yourProduct.productId)
                                            .description(yourProduct.description)
                                            .url(window.location.origin + yourProduct.slug)
                                            .variations((variationFactory) =>
                                                yourProduct.variants.map((variation) =>
                                                    variationFactory()
                                                        .name(variation.title)
                                                        .url(window.location.origin + variation.slug)
                                                        .subtitle(yourProduct.brand)
                                                        .sku(variation.variationId)
                                                        .inStock(variation.available)
                                                        .imageUrls(variation.images)
                                                        .price((priceFactory) =>
                                                            priceFactory
                                                                .original(variation.original_price)
                                                                .current(variation.price)
                                                        )
                                                )
                                            )
                                    )
                            );
                        }
                    });
                },
                error: function (err) {
                    console.log('error', err);
                }
            });
        });
    });

    oneToOneEmbed.on('provide-search-data', (searchRequest, searchResponse) => {
        const { term, page } = searchRequest;
        if (term.length < 2) {
            return searchResponse(response => {
                return response.products(p => []) // eslint-disable-line no-unused-vars
                    .currency(config.currency)
                    .locale(config.locale)
                    .pagination(p => p
                        .totalPages(0)
                        .totalMatches(0)
                        .currentPageIndex(0)
                    )
            })
        }

        $.ajax({
            url: config.urls.search + term + '&page=' + page,
            type: 'get',
            dataType: 'json',
            success: function (yourSearchResponse) {
                return searchResponse(response => {
                    return response.products(p => {
                        const results = yourSearchResponse.products.map(prod => {
                            return p()
                                .name(prod.name)
                                .imageUrl(prod.imageUrl)
                                .sku(prod.sku)
                                .price(price => price
                                    .current(prod.price.current)
                                    .original(prod.price.original || null)
                                )
                        });
                        return results;
                    })

                        .currency(config.currency)
                        .locale(config.locale)

                        .pagination(p => p
                            .totalPages(yourSearchResponse.pagination.totalPages)
                            .totalMatches(yourSearchResponse.pagination.totalMatches)
                            .currentPageIndex(yourSearchResponse.pagination.page)
                        )
                })
            },
            error: function (err) {
                console.log('error', err);
            }
        });
    });

    oneToOneEmbed.on('should-add-item-to-cart', (addedItem, callback) => {
        basketProductLineItems = JSON.parse(window.localStorage.getItem('basketProductLineItems'));
        var addToCartUrl = config.urls.addToCart;
        var form = {
            pid: addedItem.sku,
            quantity: addedItem.quantity || 1
        };
        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                Object.defineProperty(basketProductLineItems, addedItem.sku, {
                    enumerable: true,
                    value: data.pliUUID
                });
                window.localStorage.setItem('basketProductLineItems', JSON.stringify(basketProductLineItems));
                callback(true);
            },
            error: function (e) {
                console.log('add to cart error:', e);
                callback(false);
            }
        });
    });

    oneToOneEmbed.on('should-update-item-in-cart', (updatedItem, callback) => {
        basketProductLineItems = JSON.parse(window.localStorage.getItem('basketProductLineItems'));
        const pliUUID = basketProductLineItems[updatedItem.sku];
        if (pliUUID) {
            var updateCartUrl = config.urls.updateQuantity;
            var removeLineItemUrl = config.urls.removeProduct;
            updateCartUrl = updateCartUrl + '?pid=' + updatedItem.sku + '&uuid=' + pliUUID + '&quantity=' + updatedItem.quantity;
            removeLineItemUrl = removeLineItemUrl + '?pid=' + updatedItem.sku + '&uuid=' + pliUUID;
            var updateUrl = updatedItem.quantity > 0 ? updateCartUrl : removeLineItemUrl;
            $.ajax({
                url: updateUrl,
                method: 'GET',
                success: function () {
                    callback(true);
                },
                error: function (error) {
                    console.log('data update cart remove from cart error:', error);
                    callback(false);
                }
            });
        } else {
            callback(true);
        }
    });

    oneToOneEmbed.on('goto-checkout', () => {
        oneToOneEmbed.floatAbove(config.urls.checkout);
    });
}